import {useMutation, UseMutationOptions} from "@tanstack/react-query";
import {ResponseError} from "../../../models/common/Response";
import {RoleMaster} from "../../../models/config/RoleMaster";
import {AxiosError} from "axios";
import axios from "axios";

export function useDeleteRoleMaster(
    options?: UseMutationOptions<
        RoleMaster,
        AxiosError<ResponseError>,
        RoleMaster
    >
) {
    return useMutation({
        mutationFn: request => {
            const accessToken = localStorage.getItem('LG_APPLICATION');
            return axios.delete('/v1/configuration/lis/role', {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                params: {
                    sid: request.sid,
                    id: request.id,
                    menu_id: request.menu_id
                }
            });
        },
        ...options
    });
}
